export default __webpack_public_path__ + "static/media/youdont2.a9e95eb0.png";